import request from '@/utils/request'

export function retailSaleOrderPay(data) {
  return request({
    url: '/mg/daohang-order-api/retailSaleOrder/pay',
    method: 'post',
    loading: true,
    data,
  })
}
export function memberList(data) {
  return request({
    url: '/mg/daohang-member-api/memberInfo/list',
    method: 'post',
    loading: true,
    data,
  })
}
//积分可抵扣现价
export function rewardDeductAmt(data) {
  return request({
    url: '/mg/daohang-member-api/rewardRights/rewardDeductAmt',
    method: 'post',
    allowRepeat: true,
    data,
  })
}
//整单折扣
export function isPromotionHitted(data, usePromotionUid = false) {
  return request({
    url: '/mg/daohang-promotion-api/promotion/isPromotionBillHit',
    method: 'post',
    allowRepeat: true,
    usePromotionUid,
    data,
  })
}
//单品折扣
export function isSinglePromotionHitted(data, usePromotionUid = false) {
  return request({
    url: '/mg/daohang-promotion-api/promotion/isPromotionHitted',
    method: 'post',
    allowRepeat: true,
    usePromotionUid,
    data,
  })
}
//校验是否需要会员密码
export function memberVailPassword(data) {
  return request({
    url: '/mg/daohang-order-api/memberInfo/vailPassword',
    method: 'post',
    data,
  })
}
//挂单数量
export function retailSaleOrderCount(data) {
  return request({
    url: '/mg/daohang-order-api/retailSaleOrder/count',
    method: 'post',
    data,
  })
}
//清空
export function retailSaleOrderClear(data) {
  return request({
    url: '/mg/daohang-order-api/retailSaleOrder/clear',
    method: 'post',
    data,
  })
}
export function retailSkuSave(data) {
  return request({
    url: '/mg/daohang-product-api/skuCommon/retail',
    method: 'put',
    data,
  })
}
export function getDiscountAuth(params) {
  return request({
    url: '/mg/daohang-order-api/discountAuth/employeeOrCode',
    method: 'get',
    params,
  })
}
//获取系统业务配置
export function sysBusinessConfigGetOne(data) {
  return request({
    url: '/mg/daohang-basic-api/sysBusinessConfig/getOne',
    method: 'post',
    data,
  })
}

//预收银单
export function saveTempOrder(data) {
  return request({
    url: '/mg/daohang-order-api/retailSaleOrder/hangOrder',
    method: 'post',
    data,
  })
}
